import { AnyAction } from "redux";
import { initialState } from "../store/initialState";
import { actionTypeKeys } from "../actions/actionTypeKeys";
import { TimeSlot } from "../../common/types/visit";

export default function TimeSlotsReducer(state: TimeSlot[] = initialState.timeSlots, action: AnyAction): TimeSlot[] {
  switch (action.type) {
    case actionTypeKeys.LOAD_TIME_SLOTS_SUCCESS:
      return [...action.timeSlots];
    case actionTypeKeys.CLEAR_TIME_SLOTS:
      return [];
    default:
      return state;
  }
}
